<template>
  <div class="flex flex-col items-stretch w-full">
    <label class="input-label">{{ label }} <span class="text-red">*</span></label>
    <input
      v-bind="$attrs"
      :placeholder="label"
      class="field"
      :value="modelValue"
      :error="error"
      @input="$emit('update:modelValue', $event.target.value)"
    >
    <p class="py-0 p-1 mt-1 text-left text-red" v-if="error !== true && error.length > 0">{{ error }}</p>
  </div>
</template>

<script>
export default {
  name: 'BaseInput',
  props: {
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      required: true
    },
    modelValue: {
      type: [String, Number],
      default: ''
    },
    error: {
      type: [String, Boolean],
      default: false
    }
  }
}
</script>

<style>
.input-label {
  font-weight: 500;
  margin-top: 1rem;
  margin-left: 0.25rem;
  text-align: left;
}
.field {
  --tw-border-opacity: 1;
  border-color: rgba(225, 225, 225, var(--tw-border-opacity));
  border-radius: 0.375rem;
  border-width: 1px;
  font-size: 1.125rem;
  line-height: 1.75rem;
  margin-top: 0.25rem;
  padding-left: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  --tw-shadow-color: 0, 0, 0;
  --tw-shadow: 0 1px 2px 0 rgba(var(--tw-shadow-color), 0.05);
  -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.field:focus-visible {
  outline: none;
}
</style>
